<template>
	<div class="brand-store-change--modal">
		<div class="brand-store__title">
			<span class="brand-store__text-name"
				>{{ selectedBrand.name }} ({{ selectedBrand.subName || '-' }})
			</span>
			<div class="brand-store__radio">
				<span class="brand-store__text">브랜드 판매처를 일괄로 </span>
				<RadioList
					:radioList="changeList"
					:value="changeStatus"
					:size="'lg'"
					@input="brandChange"
				/>
				<span class="brand-store__text">합니다 </span>
			</div>
		</div>
		<CheckboxList
			v-model="checkedList"
			:checkboxList="dataList"
			:girdColumn="2"
		/>

		<p class="notice"># 반영은 익일에 됩니다.</p>
		<div class="btn-wrap">
			<button class="btn-main blue bordered" type="button" @click="init">
				초기화
			</button>
			<button class="btn-main blue" type="button" @click="register">
				{{ checkedList.length }} 등록
			</button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import CheckboxList from '@/components/CheckboxList';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'BrandStoreChange',
		data() {
			return {
				checkedList: [],
				changeList: [
					{ id: 'add', value: '추가' },
					{ id: 'chg', value: '교체' },
				],
				changeStatus: 'add',
			};
		},
		components: {
			CheckboxList,
			RadioList,
		},
		computed: {
			...mapState('brandList', ['storeList', 'selectedBrand']),
			dataList: {
				get() {
					return this.storeList.map(item => ({
						...item,
						value: item.name,
					}));
				},
			},
		},

		methods: {
			init() {
				this.checkedList = [];
			},
			async register() {
				if (this.checkedList.length === 0) {
					alert('판매처를 선택해 주세요.');
					return;
				}
				const params = {
					brandTypeList: this.checkedList,
					mode: this.changeStatus,
				};
				try {
					await this.$axiosAdmin2.put(
						`/api/brands/${this.selectedBrand.id}/brandType`,
						params
					);
					alert(
						`판매처 ${this.changeStatus === 'add' ? '추가' : '교체'}가 완료되었습니다.`
					);
					this.$store.commit('modal/toggleModal', false);
				} catch (error) {
					if (error.response.data?.message) {
						alert(error.response.data.message);
					} else {
						alert(
							'판매처 변경에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
						);
					}
				}
			},
			brandChange(value) {
				this.changeStatus = value;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.brand-store-change--modal {
		height: 100%;
		position: relative;

		.brand-store-change__list {
			overflow: auto;
			height: 100%;
			margin: 18px 0 0 0;
			border-top: solid 1px #ebebed;
			border-bottom: solid 1px #ebebed;

			&:after {
				content: '';
				display: block;
				clear: both;
			}
		}

		.brand-store-change__list__item {
			float: left;
			display: block;
			width: 50%;

			&:hover {
				background: #f4f7fa;
			}
		}

		.brand-store-change__label {
			overflow: hidden;
			cursor: pointer;
			display: block;
			width: 100%;
			height: 40px;
			padding: 10px;
			line-height: 20px;
			font-size: 0;
		}

		.brand-store-change__input,
		.brand-store-change__name {
			cursor: pointer;
			display: inline-block;
			line-height: 20px;
			font-size: 0.875rem;
		}

		.brand-store-change__input {
			float: left;
			margin: 4px 4px 0 0;
		}

		.brand-store-change__name {
			overflow: hidden;
			display: block;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.brand-store__title {
			font-size: 1.2rem;
			margin: 20px 0;
			display: flex;
			align-items: center;
			flex-direction: column;
			gap: 10px;
		}
		.brand-store__text-name {
			font-size: 1.5rem;
			font-weight: bold;
			color: #cb3208;
		}
		.brand-store__radio {
			display: flex;
			gap: 10px;
			align-items: center;
		}
		.btn-wrap {
			margin: 20px auto;
			text-align: center;
		}
		.notice {
			border-top: 1px solid #ebebed;
			font-weight: bold;
			text-align: center;
			margin-top: 10px;
			padding-top: 10px;
		}
	}
</style>
